import { Button } from '@mui/material';
import { FC } from 'react';
import EmptyState from '../EmptyState/EmptyState';
import LinkWithQuery from '../LinkWithQuery/LinkWithQuery';

export type PageNotFoundProps = {};

const PageNotFound: FC<PageNotFoundProps> = () => {
  return (
    <EmptyState type='404' title='Không tìm thấy trang.'>
      <Button
        fullWidth
        variant='contained'
        size='large'
        component={LinkWithQuery}
        to='/'
      >
        Về trang chủ
      </Button>
    </EmptyState>
  );
};

export default PageNotFound;
